import { z } from 'zod';
import { getBaseOasisValidationSchema } from '../../oasis';
import { SectionF } from '../../oasis-sections/section-f';
import { OASIS } from '../../oasis-types';
import { isActive, isTimepoint } from '../util';
export const sectionFConsistency = ({ input, ctx, version }) => {
    const schema = getBaseOasisValidationSchema('e1', 'soc');
    // form level
    const payload = input;
    const m2102 = payload.SectionF?.m2102;
    if (SectionF.m2102.fields?.ADL &&
        isActive(SectionF.m2102.fields.ADL, version, payload.SectionA?.m0100) &&
        isTimepoint([OASIS.DSCH], payload.SectionA?.m0100)) {
        if (!m2102?.ADL) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: `Required`,
                path: ['SectionF', 'm2102', 'ADL'],
            });
        }
    }
    if (SectionF.m2102.fields?.MDCTN &&
        isActive(SectionF.m2102.fields.MDCTN, version, payload.SectionA?.m0100) &&
        isTimepoint([OASIS.DSCH], payload.SectionA?.m0100)) {
        if (!m2102?.MDCTN) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: `Required`,
                path: ['SectionF', 'm2102', 'MDCTN'],
            });
        }
    }
    if (SectionF.m2102.fields?.PRCDR &&
        isActive(SectionF.m2102.fields.PRCDR, version, payload.SectionA?.m0100) &&
        isTimepoint([OASIS.DSCH], payload.SectionA?.m0100)) {
        if (!m2102?.PRCDR) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: `Required`,
                path: ['SectionF', 'm2102', 'PRCDR'],
            });
        }
    }
    if (SectionF.m2102.fields?.SPRVSN &&
        isActive(SectionF.m2102.fields.SPRVSN, version, payload.SectionA?.m0100) &&
        isTimepoint([OASIS.SOC, OASIS.ROC, OASIS.DSCH], payload.SectionA?.m0100)) {
        if (!m2102?.SPRVSN) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: `Required`,
                path: ['SectionF', 'm2102', 'SPRVSN'],
            });
        }
    }
};
